<template>
  <v-content>
    <AppBar title="Användare" />
    <v-container fluid>
      <v-card>
        <v-data-table
          :footer-props="footerProps"
          :loading="$apollo.loading"
          :headers="headers"
          :items="users"
          :search="search"
          loading-text="Hämtar användare..."
          no-data="Ingen data hittades..."
          no-results-text="Inget resultat på din sökning..."
          :height="tableHeight"
          :items-per-page="20"
          fixed-header
          sort-by="email"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Användare</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Sök..."
                single-line
                hide-details
                filled
                dense
              ></v-text-field>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog v-model="showUserCreateFromCsvModal" width="500">
                <template v-slot:activator="{ on }">
                  <v-btn tile color="primary" dark v-on="on">
                    <v-icon small left>mdi-plus-circle</v-icon>
                    Skapa användare från CSV
                  </v-btn>
                </template>
                <UserCreateFromCsv
                  v-if="showUserCreateFromCsvModal"
                  @confirm="refetchUsers"
                  @close="showUserCreateFromCsvModal = false"
                />
              </v-dialog>
              <v-dialog v-model="showUserCreateModal" width="500">
                <template v-slot:activator="{ on }">
                  <v-btn tile color="primary" class="ml-2" dark v-on="on">
                    <v-icon small left>mdi-plus-circle</v-icon>
                    Skapa användare
                  </v-btn>
                </template>
                <UserCreate
                  v-if="showUserCreateModal"
                  @confirm="refetchUsers"
                  @close="showUserCreateModal = false"
                />
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.access_rights="{ item }">
            {{ item.access_rights.map(x => x.name_se).join(', ') }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-menu left :close-on-click="true">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-dialog :value="showUserUpdateModal === item.id" width="500">
                  <template v-slot:activator="{ on }">
                    <v-list-item
                      v-on="on"
                      @click="showUserUpdateModal = item.id"
                    >
                      <v-list-item-icon>
                        <v-icon small>mdi-pencil</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Redigera</v-list-item-title>
                    </v-list-item>
                  </template>
                  <UserUpdate
                    :user="item"
                    v-if="showUserUpdateModal === item.id"
                    @confirm="refetchUsers"
                    @close="showUserUpdateModal = null"
                  />
                </v-dialog>
                <v-dialog :value="showUserDeleteModal === item.id" width="500">
                  <template v-slot:activator="{ on }">
                    <v-list-item
                      v-on="on"
                      @click="showUserDeleteModal = item.id"
                    >
                      <v-list-item-icon>
                        <v-icon small>mdi-delete</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Ta bort</v-list-item-title>
                    </v-list-item>
                  </template>
                  <UserDelete
                    :user="item"
                    v-if="showUserDeleteModal === item.id"
                    @confirm="refetchUsers"
                    @close="showUserDeleteModal = null"
                  />
                </v-dialog>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar.vue'
import UserCreate from './UserCreate'
import UserDelete from './UserDelete'
import UserUpdate from './UserUpdate'
import UserCreateFromCsv from './UserCreateFromCsv'
import gql from 'graphql-tag'
import tableHeight from '@/mixins/tableHeight.js'

export default {
  name: 'Användare',

  mixins: [tableHeight],

  components: {
    AppBar,
    UserCreate,
    UserDelete,
    UserUpdate,
    UserCreateFromCsv
  },

  data: () => ({
    showUserCreateModal: null,
    showUserUpdateModal: null,
    showUserDeleteModal: null,
    showUserCreateFromCsvModal: null,

    footerProps: {
      itemsPerPageOptions: [10, 20, 50],
      itemsPerPageText: 'Rader per sida'
    },
    search: '',
    headers: [
      {
        text: 'Email',
        value: 'email'
      },
      {
        text: 'Förnamn',
        value: 'first_name'
      },
      {
        text: 'Efternamn',
        value: 'last_name'
      },
      {
        text: 'Behörigheter',
        value: 'access_rights'
      },
      { text: '', value: 'actions', sortable: false, align: 'end' }
    ]
  }),

  apollo: {
    users: {
      fetchPolicy: 'cache-and-network',
      query: gql`
        query {
          users {
            id
            first_name
            last_name
            email
            access_rights {
              id
              access_id
              name_se
            }
          }
        }
      `
    }
  },

  methods: {
    refetchUsers() {
      this.showUserCreateModal = null
      this.showUserUpdateModal = null
      this.showUserDeleteModal = null
      this.showUserCreateFromCsvModal = null
      this.$apollo.queries.users.refetch()
    }
  }
}
</script>
